import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import SystemService from '@/services/API/SystemService';
import Vuetify from '@/plugins/vuetify';

import auth from '@/modules/Auth/store';
import chat from '@/modules/Chat/store';
import messages from '@/components/Layout/NavigationDrawer/store';
import modalsController from './modules/modalsController';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'vuex-sdo',
      paths: ['auth'],
    }),
  ],
  modules: {
    auth,
    chat,
    messages,
    modalsController,
  },
  state: {
    drawer: false,

    courseResources: {},
    taskResources: {},
    taskUnitResources: {},
    userResources: {},
    darkTheme: false,

    appLoading: {
      loading: false,
      target: false,
      hidden: false,
    },
    lessonResources: {},
  },
  getters: {
    courseResources(state) {
      return state.courseResources;
    },
    taskResources(state) {
      return state.taskResources;
    },
    lessonResources(state) {
      return state.lessonResources;
    },
    userResources(state) {
      return state.userResources;
    },
    darkTheme(state) {
      return state.darkTheme;
    },
    getLoadingOptions(state) {
      return state.appLoading;
    },
  },
  actions: {
    SET_DRAWER: ({ commit }, value) => {
      commit('SET_DRAWER', value);
    },
    SET_STATE({ commit }, payload) {
      commit('SET_STATE', payload);
    },
    GET_RESOURCES: (context) => {
      SystemService.getResources()
        .then((response) => {
          context.commit('SET_RESOURCES', response.data.data);
        })
        .catch(() => {
          Vue.toasted.error('Ошибка при получении данных', {
            duration: 3000,
            icon: 'alert-circle-outline',
          });
        });
    },
    SET_APP_LOADING({ commit }, val) {
      if (!val) {
        commit('RESET_APP_LOADING');
      } else {
        commit('SET_APP_LOADING_OPTIONS', val);
      }
    },
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
    SET_RESOURCES: (state, payload) => {
      state.courseResources = payload.course;
      state.taskResources = payload.task;
      state.taskUnitResources = payload.task_unit;
      state.lessonResources = payload.lesson;
      state.userResources = payload.user;
    },
    SET_APP_LOADING_OPTIONS: (state, options) => {
      Object.assign(state.appLoading, options);
    },
    RESET_APP_LOADING: (state) => {
      state.appLoading.loading = false;
      state.appLoading.target = false;
      state.appLoading.hidden = false;
    },
    SET_DARK_THEME: (state, payload) => {
      Vuetify.framework.theme.dark = payload;
      state.darkTheme = payload;
    },
    SET_DRAWER: (state, val) => {
      state.drawer = val;
    },
  },
});
